// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"72":"Cart","187":"NotFound","344":"FullPizza"}[chunkId] + "." + {"72":"77748537","187":"36312dfb","344":"2b15872b"}[chunkId] + ".chunk.js";
};